export default __webpack_public_path__ + "static/media/communityLogo.d3ca740e.png";